import {Select} from "antd";
import Portrait from "./Portrait";
import React, {FC} from "react";

interface PortraitSelectProps {
    onSelect: (key: number) => void;
    initialValue: number;
}

const PortraitSelect: FC<PortraitSelectProps> = ({onSelect, initialValue}) => {

    const [selectedIndex, setSelectedIndex] = React.useState<number>(initialValue);
    const [open, setOpen] = React.useState(false);

    const options = React.useMemo(
        () =>
            Array.from({length: 32}, (_, i) => ({
                value: i,
                label: (
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <Portrait index={i} size={75} alt={`Portrait ${i}`}/>
                    </div>
                ),
            })),
        []
    );

    return (
        <div style={{display: "flex", alignItems: "flex-start", gap: 16}}>
            {/* Aperçu cliquable */}
            <div style={{position: "relative", display: "inline-block"}}>
                <div
                    role="button"
                    aria-label="Ouvrir la sélection de portraits"
                    onClick={() => setOpen(true)}
                    style={{cursor: "pointer"}}
                >
                    <Portrait index={selectedIndex} size={200} alt={`Portrait ${selectedIndex}`}/>
                </div>

                {/* Select caché : on ne montre pas l'input, on contrôle juste le dropdown */}
                <Select
                    open={open}
                    onOpenChange={(v) => setOpen(v)}
                    value={selectedIndex}
                    onChange={(v) => {
                        setSelectedIndex(v);
                        onSelect(v);
                        setOpen(false);
                    }}
                    options={options}
                    optionLabelProp="label"
                    popupMatchSelectWidth={false}
                    styles={{
                        popup: {
                            root: {
                                maxHeight: 1000,
                                overflow: "auto",
                            },
                        },
                    }}
                    // On rend le trigger invisible mais présent pour ancrer le dropdown juste sous l’aperçu
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: 200,         // même largeur que l’aperçu pour un alignement propre
                        height: 0,
                        opacity: 0,
                        pointerEvents: "none",
                    }}
                />
            </div>
        </div>
    );
};

export default PortraitSelect;
